import { Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import DashboardContainer from 'components/PageContainer/DashboardContainer';
import Alerta from 'components/public/Alerta.tsx/Alerta';
import { useNavigate } from 'react-router-dom';
import { UsuarioDTO } from 'utils/models/types';
import LogoBosch from 'assets/logo/LogoBosch.png';
import { theme } from 'theme/theme';
import { anchoMaxLogueado } from 'utils/constants';

const Perfil = () => {
  const navigate = useNavigate();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: UsuarioDTO = usuarioJSON && JSON.parse(usuarioJSON);
  const esAdmin = usuario?.Rol === 'Administrador';
  const pathPrimario = esAdmin ? '/admin' : !usuario.EsAlumno ? '/usuario/editar' : '/usuario/mistalleres';
  const pathSecundario = '/usuario/miscompras';
  const titulo = `¡Bienvenido/a a tu cuenta, ${usuario?.Nombre}!`;

  const onClickSecundario = (pathSecundario: string) => {
    navigate(pathSecundario);
  };

  const onClickPrimario = (pathPrimario: string) => {
    navigate(pathPrimario);
  };

  return (
    <DashboardContainer>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="baseline"
        width="950px"
        maxWidth={anchoMaxLogueado}
        position="relative"
        mx="auto"
      >
        <Box mt={8} marginX="auto" className="pantallaExito" width={400}>
          <Alerta mensaje={titulo} abierto severity="success" />
          <Box height="150px" pb={4}>
            <img src={LogoBosch} alt="logo teatro bosch" />
          </Box>
          <Typography variant="h1" mb="25px" fontSize="22px">
            {titulo}
          </Typography>
          <Typography>
            Acá podrás hacer un seguimiento de tu información personal, tus compras de entradas, y tus suscripciones.
          </Typography>
          {usuario.TipoSocio !== 'Nada' && (
            <Box display="flex" justifyContent="center" textAlign="center" gap={1} mt={2}>
              <Typography variant="h6" fontSize={18}>{`Tu suscripción de socio es `}</Typography>
              <Typography variant="h6" fontSize={18} color={theme.palette.secondary.main}>
                {usuario.TipoSocio}
              </Typography>
            </Box>
          )}
          <>
            <Typography></Typography>
            <Box display="flex" gap={1}>
              <Button sx={{ my: 4, flex: 1 }} variant="contained" onClick={() => onClickPrimario(pathPrimario)}>
                {usuario.EsAlumno ? 'Mis talleres' : 'Mis datos'}
              </Button>
              <Button sx={{ my: 4, flex: 1 }} onClick={() => onClickSecundario(pathSecundario)} variant="outlined">
                Mis compras
              </Button>
            </Box>
          </>
        </Box>
      </Box>
    </DashboardContainer>
  );
};

export default Perfil;
